export default __webpack_public_path__ + "static/media/vps.667a4659.png";